import { useState } from "react"


export const EditTodoForm = ({editTodo,task}) => {
  const [value,setValue] = useState(task.task)

  const handleSubmit = (e) =>{
    e.preventDefault()

    editTodo(value,task.id)

    setValue('')
  }
  return (
    <form className='todo-form' onSubmit={handleSubmit}> 
      <input
      value={value}
       className='todo-indut'
       placeholder='Update task'
        onChange={e=>setValue(e.target.value)}
       />
      <button type='submit' className='todo-btn'>modifier</button>
    </form>
  )
}